module.exports = __webpack_public_path__ + "img/tutorial_nine_nl.360c1bc3.png";